import '../../_proto/landscope-map-viewer_pb';
import { grpcClientFactory } from './grpcClientFactory';
const COVERAGE_STATE_BY_VALUE = {
    0: 'unspecified',
    1: 'instant',
    2: 'procurable',
    3: 'none',
};
class LidarCoverageService {
    constructor() {
        this.client = grpcClientFactory.createLidarCoverageClient({ enableCompression: true });
    }
    /**
     * Check if LiDAR coverage is available for the given coordinates
     */
    async checkCoverageAvailability(request) {
        return new Promise((resolve, reject) => {
            try {
                // Create the protobuf request
                const CheckCoverageAvailabilityRequest = proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest;
                const grpcRequest = new CheckCoverageAvailabilityRequest();
                // Convert coordinates to protobuf format
                const coordinatesList = request.coordinates.map(coord => {
                    const Coordinate = proto.landscope.mapviewer.v1.Coordinate;
                    const protoCoord = new Coordinate();
                    protoCoord.setLatitude(coord.lat);
                    protoCoord.setLongitude(coord.lng);
                    return protoCoord;
                });
                grpcRequest.setCoordinatesList(coordinatesList);
                // Make the gRPC call
                this.client.checkCoverageAvailability(grpcRequest, {}, (error, response) => {
                    var _a;
                    if (error) {
                        console.error('LidarCoverageService: Coverage check failed:', error);
                        reject(new Error(`Coverage check failed: ${error.message}`));
                        return;
                    }
                    if (!response) {
                        console.error('LidarCoverageService: No response received');
                        reject(new Error('No response received from coverage service'));
                        return;
                    }
                    const available = response.getAvailable();
                    resolve({
                        available: available,
                        state: (_a = COVERAGE_STATE_BY_VALUE[response.getState()]) !== null && _a !== void 0 ? _a : 'unspecified',
                    });
                });
            }
            catch (error) {
                console.error('LidarCoverageService: Error in checkCoverageAvailability:', error);
                reject(error);
            }
        });
    }
}
// Export singleton instance
export const lidarCoverageService = new LidarCoverageService();
